import React from "react";
import { Link } from "react-router-dom";
import { FaScroll, FaEdit, FaTrash, FaEye } from "react-icons/fa";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";

const SyllabusDetailPanel = ({ syllabus, permissions, onDelete, onViewFile }) => {
  if (!syllabus) {
    return (
      <div className="syllabus-detail-panel">
        <div className="syllabus-detail-empty">Select a syllabus to view details</div>
      </div>
    );
  }

  const classes = syllabus.syllabus_programs || [];

  return (
    <div className="syllabus-detail-panel">
      <div className="syllabus-detail-header">
        <div className="syllabus-detail-heading">
          <span className="syllabus-detail-icon">
            <FaScroll />
          </span>
          <div>
            <div className="syllabus-detail-title">{syllabus.subject?.name}</div>
            {classes.length > 0 && (
              <div className="syllabus-detail-classes">
                {classes.map((item, idx) => (
                  item.program && (
                    <span key={idx} className="syllabus-detail-class-chip">{item.program.name}</span>
                  )
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="syllabus-detail-actions">
          {syllabus.syllabus_docs && (
            <span
              className="syllabus-action-btn"
              role="button"
              onClick={() => onViewFile(syllabus.syllabus_docs)}
            >
              <FaEye /> View File
            </span>
          )}
          {permissions.includes("syllabus.delete") && (
            <Link
              to={`/syllabus/update/${syllabus.id}`}
              className="syllabus-action-btn"
              title="Edit"
            >
              <FaEdit /> Edit
            </Link>
          )}
          {permissions.includes("syllabus.delete") && (
            <span
              className="syllabus-action-btn syllabus-delete-btn"
              title="Delete"
              role="button"
              onClick={() => {
                if (window.confirm("Are you sure you wish to delete this item?"))
                  onDelete(syllabus.id);
              }}
            >
              <FaTrash /> Delete
            </span>
          )}
        </div>
      </div>

      <div
        className="syllabus-detail-body"
        // eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in sanitizeHtml() above
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(syllabus.syllabus_desc) }}
      />
    </div>
  );
};

export default SyllabusDetailPanel;
